import React, { Fragment, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';

import { pageDefinition } from 'site-modules/shared/pages/page';

import { TrackingHandler } from 'client/tracking/handler';
import { TrackingMap } from 'client/tracking/maps/dashboard';
import { TrackingMap as SignUpTrackingMap } from 'client/tracking/maps/insider/sign-up';
import { insiderPage } from 'site-modules/profile/pages/common/insider-page/insider-page';
import { profileScreenMethods } from 'site-modules/shared/components/profile/profile-screen-methods';
import { InsiderPageHeader } from 'site-modules/profile/components/shared/insider-page-header/insider-page-header';
import { SettingsLanding } from 'site-modules/profile/components/settings/settings-landing/settings-landing';
import { redirect } from 'site-modules/shared/utils/profile/dashboard-helper';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';

import 'site-modules/shared/components/profile/profile.scss';
import './settings.scss';

function SettingsPageUI({
  isMobile,
  slug,
  hasDataIdm = false,
  isAnonymousUser = false,
  hasProfileScreen = false,
  toggleSignModal,
}) {
  const profileScreenWasOpen = useRef(null);

  useEffect(() => {
    if (hasDataIdm && !isAnonymousUser) {
      return;
    }

    if (hasDataIdm && !hasProfileScreen) {
      if (profileScreenWasOpen.current === true) {
        redirect({ isMobile });
      } else {
        TrackingHandler.useMap(SignUpTrackingMap);
        TrackingHandler.fireEvent('view_sign_up');
        profileScreenWasOpen.current = true;
        toggleSignModal();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasProfileScreen, hasDataIdm]);

  return (
    <Fragment>
      {isMobile && <InsiderPageHeader slug={slug} />}
      {!isAnonymousUser && <SettingsLanding isMobile={isMobile} />}
    </Fragment>
  );
}

SettingsPageUI.propTypes = {
  slug: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  toggleSignModal: PropTypes.func.isRequired,
  hasDataIdm: PropTypes.bool,
  isAnonymousUser: PropTypes.bool,
  hasProfileScreen: PropTypes.bool,
};

const mapStateToProps = state => ({
  hasProfileScreen: !!get(state, 'profile.screen'),
});

export const SettingsPage = connect(mapStateToProps)(SettingsPageUI);

const Settings = profileScreenMethods(
  insiderPage(SettingsPage, {
    map: TrackingMap,
    parent: 'edm-entry-dashboard-settings',
  })
);

export const getSettingsPageDefinition = slug => ({
  name: 'dashboard_settings',
  category: 'dashboard_page',
  component: () => <Settings slug={slug} />,
  decorator: EdmundsCpaNoAdhesionDecorator,
  seo: {
    title: 'Edmunds Insider Membership Dashboard - Account Settings',
    description: 'Access your Insider settings. Update your contact information, password, and email preferences.',
    robots: {
      noFollow: true,
      noIndex: true,
    },
  },
});

export default ({ slug }) => pageDefinition(getSettingsPageDefinition(slug));
